module.exports = __webpack_public_path__ + "media/npc_dota_hero_phantom_lancer.fc1abeab.webm";